module.exports = __webpack_public_path__ + "static/media/reading.5eb8951c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/reading.png
// module id = 1478
// module chunks = 31